import SidebarBookingsSummaryRoute from 'uplisting-frontend/pods/-sidebar/bookings/summary/route';

export default class ProtectionOverviewBookingsSummaryRoute extends SidebarBookingsSummaryRoute {
  parentRoute = 'protection.overview.bookings';
}
